module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    class: _vm.componentClass
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.legalCaseExists) ? _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  })]) : _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.newTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('objectTab')
      }
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.existingTab
    }
  }, [_vm._v("Existing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.newTab
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.objectTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.objectTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('objectTab')
      }
    }
  }, [_vm._v("Object")])]), _vm._v(" "), _c('li', {
    class: _vm.detailsTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.detailsTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('detailsTab')
      }
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    class: _vm.storageTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.storageTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('storageTab')
      }
    }
  }, [_vm._v("Storage")])]), _vm._v(" "), _c('li', {
    class: _vm.disposalTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.disposalTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('disposalTab')
      }
    }
  }, [_vm._v("Disposal")])]), _vm._v(" "), (!_vm.parentModal) ? _c('li', {
    class: _vm.relatedItemsTabListClass
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.relatedItemsTab
    },
    on: {
      "click": function($event) {
        return _vm.updateTabSelected('relatedItemsTab')
      }
    }
  }, [_vm._v("Related Items")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    class: _vm.objectTabClass,
    attrs: {
      "id": _vm.objectTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": _vm.artifactTypeDisplay,
      "Index": "0",
      "hideHeader": !_vm.physicalArtifactIdExists
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Physical Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.physical_artifact_type_id),
      expression: "physical_artifact.physical_artifact_type_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "physical_artifact_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.loadSchema]
    }
  }, _vm._l((_vm.physicalArtifactTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                                  " + _vm._s(option.artifact_type_display) + "\n                                                ")])
  }), 0)])])])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-6"
  }, [_vm._v("Object used within this case?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.used_within_case),
      expression: "physical_artifact.used_within_case"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.physical_artifact.used_within_case, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "used_within_case", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.used_within_case),
      expression: "physical_artifact.used_within_case"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.physical_artifact.used_within_case, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "used_within_case", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "no"
    }
  }, [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-6"
  }, [_vm._v("Object is sensitive / non-disclosable?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.sensitive_non_disclosable),
      expression: "physical_artifact.sensitive_non_disclosable"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "yes",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.physical_artifact.sensitive_non_disclosable, true)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "sensitive_non_disclosable", true)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.sensitive_non_disclosable),
      expression: "physical_artifact.sensitive_non_disclosable"
    }],
    staticClass: "col-sm-1",
    attrs: {
      "disabled": _vm.readonlyForm,
      "id": "no",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.physical_artifact.sensitive_non_disclosable, false)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.physical_artifact, "sensitive_non_disclosable", false)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1",
    attrs: {
      "for": "no"
    }
  }, [_vm._v("No")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.identifier),
      expression: "physical_artifact.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.physical_artifact.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "identifier", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Officer")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    ref: "physical_artifact_officers",
    staticClass: "form-control",
    attrs: {
      "id": "physical_artifact_officers",
      "name": "physical_artifact_officers"
    }
  })])])]), _vm._v(" "), (_vm.statementVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Statement")])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.statement_id),
      expression: "physical_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.legal_case.statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                                " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                                ")])
  }), 0)]) : _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.statement_id),
      expression: "physical_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.physical_artifact.available_statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                                " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                                ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.custodianVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Custodian")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_vm._v("\n                                                        " + _vm._s(_vm.selectedStatementArtifact.custodian) + "\n                                                ")])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Custodian")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    ref: "physical_artifact_custodians",
    staticClass: "form-control",
    attrs: {
      "id": "physical_artifact_custodians",
      "name": "physical_artifact_custodians"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.artifact_date),
      expression: "physical_artifact.artifact_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.physical_artifact.artifact_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "artifact_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactTimePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.artifact_time),
      expression: "physical_artifact.artifact_time"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.physical_artifact.artifact_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "artifact_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.description),
      expression: "physical_artifact.description"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.physical_artifact.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.siezureNoticeVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Seizure Notice")])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "default_document",
    attrs: {
      "name": "default_document",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document",
      "readonly": _vm.readonlyForm
    },
    on: {
      "update-temp-doc-coll-id": _vm.addToTemporaryDocumentCollectionList
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "physical_artifact_documents",
    attrs: {
      "name": "physical-artifact-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.physical_artifact.defaultDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)])]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    key: _vm.artifactType,
    class: _vm.detailsTabClass,
    attrs: {
      "id": _vm.detailsTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.detailsSchema), function(item, index) {
    return (_vm.detailsSchemaVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      },
      on: {
        "update-temp-doc-coll-id": _vm.addToTemporaryDocumentCollectionList
      }
    })], 1) : _vm._e()
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    class: _vm.storageTabClass,
    attrs: {
      "id": _vm.storageTab
    }
  }, [_c('FormSection', {
    key: _vm.artifactType,
    attrs: {
      "formCollapse": false,
      "label": "Storage"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.storageSchema), function(item, index) {
    return (_vm.storageSchemaVisibility) ? _c('div', [_c('compliance-renderer-block', {
      key: ("compliance_renderer_block" + index),
      attrs: {
        "component": item,
        "readonlyForm": _vm.readonlyForm
      }
    })], 1) : _vm._e()
  }), 0)])])], 1), _vm._v(" "), _c('div', {
    class: _vm.disposalTabClass,
    attrs: {
      "id": _vm.disposalTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Disposal"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Disposal Method")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.disposal_method),
      expression: "physical_artifact.disposal_method"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.physical_artifact, "disposal_method", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.disposalMethods), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                                              " + _vm._s(option.disposal_method) + "\n                                            ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "disposalDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.disposal_date),
      expression: "physical_artifact.disposal_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.physical_artifact.disposal_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "disposal_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Disposal details")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.physical_artifact.disposal_details),
      expression: "physical_artifact.disposal_details"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.physical_artifact.disposal_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.physical_artifact, "disposal_details", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), (!_vm.parentModal) ? _c('div', {
    class: _vm.relatedItemsTabClass,
    attrs: {
      "id": _vm.relatedItemsTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm,
      "parentComponentName": "physical_artifact"
    }
  })], 1) : _vm._e()])])])], 1) : _vm._e()])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "tab-pane fade in li-top-buffer",
    attrs: {
      "id": _vm.existingTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "existing_artifact_table",
    attrs: {
      "id": "existing-artifact-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4123c7bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/physical_artifact_component.vue
// module id = 960
// module chunks = 0